// extracted by mini-css-extract-plugin
export default {"footer":"index-module_footer_lwpqP","links":"index-module_links_JO-ne","divider":"index-module_divider_wuCvW","span":"index-module_span_--wW1"};